import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
`;
export const RoomHeader = styled.div`
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
`;

export const DeleteRoomButton = styled.button`
  background-color: transparent;
  border: none;
  display: flex;
  align-items: center;
  gap: 14px;
  cursor: pointer;
`;

export const Label = styled.span<{ size: number }>`
  font-size: ${({ size }) => size}px;
  font-weight: 700;
  color: ${({ theme }) => theme.palette.persianRed};
`;

export const RoomContent = styled.div`
  background: ${({ theme }) => theme.palette.lynxWhite};
  padding: 20px;
  border-radius: 8px;
`;
